import React from 'react';
import { CommonPrelanderV3 } from '../../components/CommonPrelanderV3';
import { QUIZ_SLIDES_V29 } from '../../shared/quiz-slides/quiz-slides-v29';

function PrelanderV48Page({ initialPrelander }) {
    return (
        <CommonPrelanderV3
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V29}
        />
    );
}

export {
    PrelanderV48Page
};
